import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "341",
  "slug": "spot-madagascar-from-satellite-imagery",
  "title": "How to Recognise Madagascar in Satellite Images",
  "excerpt": "Madagascar is a long island east of Mozambique, separated from the mainland by the Mozambique Channel.",
  "date": "2026-06-03",
  "category": "Geography",
  "image": "/blog-images/madagascar.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Madagascar is a long island east of Mozambique, separated from the mainland by the Mozambique Channel. A regional image shows the central highlands and a relatively narrow eastern coastal strip; many western rivers have more room to develop across lower terrain."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Locate the whole island before examining a smaller crop. A red soil patch or eroded slope is not unique to Madagascar, and green cover does not identify a forest type without more information. Trace a river from the highlands toward the coast and compare how the drainage differs on the two sides."
    }
  ],
  "imageAlt": "Madagascar regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
